export enum TelematicsSource {
  IMPORTED = 'imported',
  MANUAL = 'manual',
  TELEMATICS = 'telematics',
  CALIBRATION = 'calibration',
  NATIVE_APP_IMPORTED = 'native_app_imported'
}
